"use client";

import ListingOneArea from "./ListingOneArea";
import FooterFive from "@/layouts/footers/FooterFive";
import { useEffect, useState } from "react";
import axiosInstance from "@/service/axiosInstance";
import {
  getSortedSectionsWRTType,
  getSortedSectionsWRTpage,
} from "@/utils/utils";
import Loader from "@/components/Loader/Loader";
import { useSearchParams } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { addFilter } from "@/redux/features/filterSlice";
import ListingPsaArea from "./ListingPsaArea";
import { ONE_MODULES } from "@/utils/enum";
import { selectVivaCartItems } from "@/redux/features/vivaCartSlice";
import ClearCart from "@/components/clearCart";
import Vc3PreEventlisting from "../../embrace/vc3PreEventlisting";
import EnrollmentModal from "@/components/embrace/EnrollmentModal";
import { getFeeDescription } from "@/utils/feeDescriptionMap";
import { selectCartItems } from "@/redux/features/cartSlice";
import PreEventListingOneVafp from "@/components/vafp/preEventlisting";

const ListingOne = () => {
  const dispatch = useDispatch();
  const searchParams = useSearchParams();
  const cart: any = useSelector(selectCartItems);
  // const redirect: any = searchParams.get("path");
  const [loading, setLoading] = useState(false);
  const [footerData, setFooterData] = useState([[]]);
  const [socialMedia, setSocialMedia] = useState([]);
  const vivaCart = useSelector(selectVivaCartItems);
  const [checkPsa, setCheckPsa] = useState(false);
  const [checkVc3, setCheckVc3] = useState(false);
  const [checkVafp, setCheckVafp] = useState(false);
  const [cartSafe, setCartSafe] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [isCartSafe, setIsCartSafe] = useState(false);
  const totalItemsInCart = cart.reduce(
    (total: number, item: { inCart: number }) => total + item.inCart,
    0,
  );
  const feeDescriptionId = getFeeDescription(ONE_MODULES.VC3);

  const hasDifferentFees = cart.some(
    (item: any) =>
      item.attributes.fees_description.data.id !== feeDescriptionId,
  );
  // const check:any=window.location.pathname.includes("/vc3")
  // console.log("🚀 ~ ListingOne ~ check:", check)
  const userData = useSelector((state: any) => state.user.data);

  const getData = async () => {
    try {
      // const token = localStorage.getItem("token");
      setLoading(true);

      const resp: any = await axiosInstance.get("/homePage", {});
      // if (token) {
      //   if (
      //     resp?.isAuthorized?.status == 401 ||
      //     resp?.isAuthorized?.message == "Token has expired"
      //   ) {
      //     console.log("Token has expired!");
      //     toast.error("Session expired please login again", {
      //       position: toast.POSITION.TOP_RIGHT,
      //       autoClose: 3000,
      //     });
      //     localStorage.removeItem("token");
      //     dispatch(logout());

      //     // router.push(`/login?redirect="true"`);

      //     // return;
      //   }
      // }

      // let updated = resp?.data;

      // setCount(resp?.meta.pagination.total);

      const footerData1 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 1",
      );

      const footerData2 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 2",
      );

      const footerData3 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 3",
      );
      const socialMediaData = getSortedSectionsWRTpage(
        resp?.data?.data,
        "Social Media",
        "Home Page",
      );
      setSocialMedia(socialMediaData);

      setFooterData([footerData1, footerData2, footerData3]);

      // Create a new object containing the filtered data
      // const filteredApiResponse = { data: filteredData };

      //   setData(resp?.data?.data);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
    if (vivaCart.length > 0) {
      setCartSafe(false);
      setShowConfirmModal(true);
    } else {
      setCartSafe(true);
    }
    if (typeof window !== "undefined") {
      setCheckPsa(window.location.pathname.includes("/psa"));
      setCheckVc3(window.location.pathname.includes("/vc3"));
      setCheckVafp(window.location.pathname.includes("/vafp"));
    }
    // return () => {
    //   dispatch(addFilter(emptyFilter));
    // };
  }, []);

  useEffect(() => {
    if (showConfirmModal && vivaCart.length === 0) {
      setCartSafe(true);
      setShowConfirmModal(false);
    }
  }, [vivaCart, showConfirmModal]);

  useEffect(() => {
    if (hasDifferentFees && totalItemsInCart > 0) {
      setShowConfirmModal(true);
    } else {
      setIsCartSafe(true);
    }
  }, [hasDifferentFees, totalItemsInCart]);

  return (
    <>
      <html>
        <head>
          <title>
            Exciting Sports Competitions & Games - Vibgyor Viva Event
          </title>
          <meta
            name="description"
            content="Explore a wide range of exciting sports events and competitions at the Vibgyor Viva Event. Join us for thrilling activities, detailed event types, and registration information!"
          />
          <meta
            name="keywords"
            content="sports events, competitions, games, Vibgyor Viva Event"
          />
        </head>
      </html>

      {loading && <Loader />}
      {showConfirmModal && <ClearCart />}
      {!isEnrolled && !userData?.School && checkVc3 && (
        <>
          <div className="absolute inset-0 backdrop-blur-lg bg-black/50 z-10"></div>
          <EnrollmentModal
            show={!isEnrolled}
            handleClose={() => setIsEnrolled(true)}
          />
        </>
      )}
      {checkVc3 && cartSafe && <Vc3PreEventlisting module={ONE_MODULES.VC3} />}
      {/* <HeaderOne style={true} /> */}
      {!checkPsa && !checkVafp && cartSafe && !checkVc3 && <ListingOneArea />}

      {checkPsa && <ListingPsaArea />}
      {checkVafp && <PreEventListingOneVafp module={ONE_MODULES.VAFP} />}
      {/* <FancyBanner /> */}
      {cartSafe && <FooterFive data={footerData} socialMedia={socialMedia} />}
    </>
  );
};

export default ListingOne;
